import {
  LANGUAGE_LABELS,
  MAX_LANGUAGES,
  MAX_SPECIALTIES,
  SPECIALTY_LABELS,
} from "@sill/shared/lib/descriptor-labels";

import type { ProIdentity } from "./marketplace-offers-api";

// Buyer-side rendering of the agent profile descriptors (plan 444 M3). The
// server sends vocabulary codes; labels come from the shared map the pro
// editor also reads, so a pro and a buyer see the same words. A code the map
// does not know (a vocabulary newer than this bundle) is dropped rather than
// rendered raw.

export interface DescriptorChip {
  code: string;
  label: string;
}

function chips(
  codes: readonly string[] | undefined,
  labels: Record<string, string>,
  cap: number,
): DescriptorChip[] {
  const out: DescriptorChip[] = [];
  for (const code of codes ?? []) {
    const label = labels[code];
    if (label && !out.some((chip) => chip.code === code)) {
      out.push({ code, label });
    }
  }
  return out.slice(0, cap);
}

/** Specialty chips for a card, capped at the editor's own limit. */
export function specialtyChips(
  identity: Pick<ProIdentity, "specialties">,
): DescriptorChip[] {
  return chips(identity.specialties, SPECIALTY_LABELS, MAX_SPECIALTIES);
}

/**
 * Language chips for a card. English is implicit for every agent, so it never
 * renders even if a payload carries it (the shared label map has no entry).
 */
export function languageChips(
  identity: Pick<ProIdentity, "languages">,
): DescriptorChip[] {
  return chips(identity.languages, LANGUAGE_LABELS, MAX_LANGUAGES);
}
